module.exports = __webpack_public_path__ + "img/icon-speed-4.262ca387.svg";